import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';

import tassAxios from '@/apis/tass-api/axios';

export type CreateUserRequest = {
  email: string;
  organizationId: string;
};

type CreateUserResponse = {
  id: string;
  email: string;
};

const createUser = async (user: CreateUserRequest) => {
  const { data } = await tassAxios.post<CreateUserResponse>('/api/Admin/CreateUser', user);
  return data;
};

export const useCreateUser = () => {
  return useMutation({
    mutationFn: createUser,
    onError: () => toast.error('An error occurred while creating the user'),
  });
};
